/* eslint-disable */
export const boardEn = {
  'Add task': 'Add task',
  'Delete': 'Delete',

};

export const boardRu = {
  'Add task': 'Добавить задание',
  'Delete': 'Удалить',
  'Delete column': 'Удалить колонку',
  'Add column': 'Добавить колонку',
  'Board': 'Доска',
  'Description': 'Описание',
  'Edit User Profile': 'Редактировать профиль',
  'Delete User': 'Удалить пользователя',
  'Edit Profile Page of user': 'Страница редактирования профиля',
  'Edit Your profile': 'Измените свой профиль',
  'This field is required': 'Это поле обязательно',
  'Confirm Change': 'Подтвердить изменения',
  'Are you shore to delete': 'Вы действительно хотите удалить ',
  'board': 'доску',
  'user': 'пользователя',
  'Yes': 'Да',
  'No': 'Нет',
};
/* eslint-disable */